module.exports = {"desc":"自动生成的配置文件，不要编辑本文件！！！","name":"合景泰富","displayName":"合景泰富","httpBaseUrl":"https://managerpoo.kwgcloud.com","output":"/src/constants","env":"prod"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/env.json
// module id = 461
// module chunks = 0